import { gql } from '@apollo/client';

export const GET_ME = gql`
  query Me {
    me {
      id
      username
      email
      confirmed
      name
      plan
      subscriptionStatus
      subscriptionCurrentPeriodEnd
      cancelAtPeriodEnd
    }
  }
`;

export const GET_WORKOUTS = gql`
  query Workouts {
    workouts {
      data {
        id
        attributes {
          name
          description
          image
          authorEmail
          motivation
          voiceInstructions
          exercises
        }
      }
    }
  }
`;

// What a guided workout reads from the library for its exercises: the muscles each works and the equipment (the
// step its load moves by). The steps come with the workout's own entries (howTo)
export const GET_SESSION_EXERCISES = gql`
  query SessionExercises($ids: [String]) {
    exercises(filters: { exerciseId: { in: $ids } }, pagination: { pageSize: 100 }) {
      data {
        id
        attributes {
          exerciseId
          muscleGroup
          otherMuscles
          equipmentCategory
        }
      }
    }
  }
`;

export const GET_ACADEMY_CATEGORIES = gql`
  query AcademyCategories {
    academyCategories(sort: "order:asc") {
      data {
        id
        attributes {
          namePt
          nameEn
          slug
          order
          videos
        }
      }
    }
  }
`;

// The Central de Aprendizado videos the member has watched, by YouTube id: { t, d, done, at }
export const GET_ACADEMY_PROGRESS = gql`
  query AcademyProgress {
    academyProgress
  }
`;

export const GET_EXERCISES = gql`
  query Exercises($page: Int, $pageSize: Int, $search: String, $muscleGroup: String, $equipment: String) {
    exercises(
      pagination: { page: $page, pageSize: $pageSize }
      filters: {
        title: { containsi: $search }
        muscleGroup: { eq: $muscleGroup }
        equipmentCategory: { eq: $equipment }
      }
      sort: "title:asc"
    ) {
      data {
        id
        attributes {
          exerciseId
          title
          titlePt
          videoUrl
          thumbnailUrl
          mediaType
          muscleGroup
          otherMuscles
          equipmentCategory
          exerciseType
          localisedInstructions
          priority
        }
      }
      meta {
        pagination {
          page
          pageSize
          pageCount
          total
        }
      }
    }
  }
`;

export const GET_EXERCISE_FILTERS = gql`
  query ExerciseFilters {
    exercises(pagination: { pageSize: 1500 }, sort: "title:asc") {
      data {
        id
        attributes {
          exerciseId
          title
          titlePt
          videoUrl
          thumbnailUrl
          mediaType
          muscleGroup
          otherMuscles
          equipmentCategory
          exerciseType
          localisedInstructions
          priority
        }
      }
    }
  }
`;

// The library's muscle and equipment for the exercises of a generated split (the AI sends only their ids and names)
export const GET_SPLIT_EXERCISES = gql`
  query SplitExercises($ids: [String]) {
    exercises(filters: { exerciseId: { in: $ids } }, pagination: { pageSize: 200 }) {
      data {
        id
        attributes {
          exerciseId
          muscleGroup
          equipmentCategory
        }
      }
    }
  }
`;

export const GET_DIET_PLAN = gql`
  query DietPlan {
    dietPlan {
      data {
        id
        attributes {
          weekPlan
          nutritionData
          questionnaire
          origin
          substitutions
          originalWeekPlan
          notes
        }
      }
    }
  }
`;

export const GET_WORKOUT_LOGS = gql`
  query WorkoutLogs($workoutId: ID) {
    workoutLogs(
      filters: { workout: { id: { eq: $workoutId } } }
      sort: "completedAt:desc"
      pagination: { pageSize: 200 }
    ) {
      data {
        id
        attributes {
          completedAt
          duration
          exercises
          workout {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

// No meta { pagination } here: the API's workoutLogs resolver (scoped to the author) can't answer it, and asking
// for it failed the whole query, so Início and Meus Treinos read no sessions at all
export const GET_WORKOUT_LOGS_STATS = gql`
  query WorkoutLogsStats {
    workoutLogs(
      sort: "completedAt:desc"
      pagination: { pageSize: 200 }
    ) {
      data {
        id
        attributes {
          completedAt
          duration
          exercises
          workout {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_CALORIE_LOGS = gql`
  query CalorieLogs($dateGte: Date, $dateLte: Date) {
    calorieLogs(
      filters: { date: { gte: $dateGte, lte: $dateLte } }
      sort: "date:desc"
      pagination: { pageSize: 10 }
    ) {
      data {
        id
        attributes {
          date
          entries
          totalCalories
        }
      }
    }
  }
`;

export const SEARCH_FOODS = gql`
  query SearchFoods($query: String!, $lang: String) {
    searchFoods(query: $query, lang: $lang) {
      id
      name_pt
      name_en
      category
      calories
      protein
      carbs
      fat
      fiber
      source
    }
  }
`;

export const GET_BANNER = gql`
  query Banner {
    banner {
      data {
        attributes {
          banner
        }
      }
    }
  }
`;
